import { useEffect, useState } from "react";
import { getSession, login, logout, Session } from "../../Core/Auth/adapter";
import { validCredentialsFn } from "./Functions";
export function useDashboardSession() {
  const [session, setSession] = useState<Session | null>(null);
  const [busy, setBusy] = useState(true);
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  useEffect(() => {
    let active = true;
    getSession().then((result) => {
      if (!active) return;
      if (result.ok) setSession(result.value);
      else if (result.code !== "forbidden")
        setMessage(
          "The dashboard service is not connected. Configure production authentication and publishing before customer use."
        );
      setBusy(false);
    });
    return () => {
      active = false;
    };
  }, []);
  async function signIn() {
    if (busy || !validCredentialsFn(email, password)) return;
    setBusy(true);
    const result = await login(email, password);
    if (result.ok) {
      setSession(result.value);
      setPassword("");
      setMessage("");
    } else setMessage(result.message);
    setBusy(false);
  }
  async function signOut() {
    const result = await logout();
    if (result.ok) setSession(null);
    else setMessage(result.message);
  }
  return {
    session,
    busy,
    message,
    email,
    password,
    setEmail,
    setPassword,
    signIn,
    signOut,
  };
}
